module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = vHs2
// module chunks = 3